import { reatomAsync } from "@reatom/async";
import { BalanceByUserIdRequestDto } from "definitions/poizon-bff";
import { API } from "src/api";

export const depositCredits = reatomAsync(
  async (ctx, data: BalanceByUserIdRequestDto) => {
    await API.awardAdminApi.awardAdminOrderControllerBalanceByUserId(data);
  },
  "depositCredits",
);
